import { useState } from "react";
import { Brain, BookOpen, Zap } from "lucide-react";
import HamburgerMenu from "../../assets/hamburger.svg";
import ShortLogo from "../../assets/short-logo.svg";

export default function Questionnaire() {
  const [tutorStyle, setTutorStyle] = useState("Socrates");

  return (
    <div className="max-w-md mx-auto px-4 py-8 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <img src={ShortLogo} alt="Short Logo" className="w-10 h-10" />
        <img src={HamburgerMenu} alt="Menu" className="w-6 h-6" />
      </div>

      <h1 className="text-xl font-bold leading-snug">
        Start your personalized learning journey with AI tutor that helps you to get ahead
      </h1>

      <input
        type="text"
        placeholder="How should we call you?"
        className="border border-gray-300 rounded-lg px-4 py-3 w-full"
      />
      <input
        type="text"
        placeholder="What would you like to learn?"
        className="border border-gray-300 rounded-lg px-4 py-3 w-full"
      />
      <input
        type="text"
        placeholder="What's your current level?"
        className="border border-gray-300 rounded-lg px-4 py-3 w-full"
      />

      <div>
        <label className="block text-sm font-medium mb-2">Choose your tutor style:</label>
        <div className="flex flex-col gap-3">
          {[
            {
              value: "Socrates",
              icon: <Brain size={18} />,
              title: "Socrates",
              desc: "Questions that lead to understanding",
            },
            {
              value: "Aristotle",
              icon: <BookOpen size={18} />,
              title: "Aristotle",
              desc: "Systematic and logical approach",
            },
            {
              value: "Einstein",
              icon: <Zap size={18} />,
              title: "Einstein",
              desc: "Creative and imaginative thinking",
            },
          ].map((option) => (
            <label
              key={option.value}
              className={`flex items-start gap-3 p-4 border rounded-lg cursor-pointer ${
                tutorStyle === option.value ? "border-blue-600 bg-blue-50" : "border-gray-300"
              }`}
            >
              <input
                type="radio"
                name="tutorStyle"
                value={option.value}
                checked={tutorStyle === option.value}
                onChange={() => setTutorStyle(option.value)}
                className="mt-1"
              />
              <div className="flex gap-2">
                {option.icon}
                <div>
                  <p className="font-medium text-sm">{option.title}</p>
                  <p className="text-sm text-gray-500">{option.desc}</p>
                </div>
              </div>
            </label>
          ))}
        </div>
      </div>

      <button
        className="bg-blue-600 text-white w-full py-3 rounded-xl font-bold text-base mt-2 hover:bg-blue-700 transition"
      >
        Start learning
      </button>
    </div>
  );
}
